"use client";

import * as Sentry from "@sentry/nextjs";
import { Button, Flex, Typography } from "antd";
import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
    console.error(error);
  }, [error]);

  return (
    <Flex
      vertical
      align="center"
      justify="center"
      gap={16}
      style={{ minHeight: "50vh", padding: 24 }}
    >
      <Typography.Title level={4}>Something went wrong</Typography.Title>
      <Typography.Text type="secondary">
        We couldn&apos;t load this page. Please try again.
      </Typography.Text>
      <Button type="primary" onClick={reset}>
        Try again
      </Button>
    </Flex>
  );
}
